<template>
  <div>
    <Edit
      :modoDeEdicao="modoDeEdicao"
      :adquirente="currentAdquirente"
      :cobrancasDisponiveis="cobrancasDisponiveis"
      :gatewaysDisponiveis="gatewaysDisponiveis"
      :ordensDisponiveis="ordensDisponiveis"
      :salvar="salvar"
      :close="closeEdit"
      :resetEdit="resetEdit"
    ></Edit>

    <div class="listagem__filtros">
      <div class="search-wrapper" style="width: 280px">
        <input
          type="text"
          class="form-control"
          v-model="filtros.termo"
          placeholder="Buscar por nome ou gateway..."
          style="height: 38px; padding-right: 35px"
        />
        <img
          class="search-icon"
          src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2Ljk2NiA1Ni45NjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2Ljk2NiA1Ni45NjY7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPHBhdGggZD0iTTU1LjE0Niw1MS44ODdMNDEuNTg4LDM3Ljc4NmMzLjQ4Ni00LjE0NCw1LjM5Ni05LjM1OCw1LjM5Ni0xNC43ODZjMC0xMi42ODItMTAuMzE4LTIzLTIzLTIzcy0yMywxMC4zMTgtMjMsMjMgIHMxMC4zMTgsMjMsMjMsMjNjNC43NjEsMCw5LjI5OC0xLjQzNiwxMy4xNzctNC4xNjJsMTMuNjYxLDE0LjIwOGMwLjU3MSwwLjU5MywxLjMzOSwwLjkyLDIuMTYyLDAuOTIgIGMwLjc3OSwwLDEuNTE4LTAuMjk3LDIuMDc5LTAuODM3QzU2LjI1NSw1NC45ODIsNTYuMjkzLDUzLjA4LDU1LjE0Niw1MS44ODd6IE0yMy45ODQsNmM5LjM3NCwwLDE3LDcuNjI2LDE3LDE3cy03LjYyNiwxNy0xNywxNyAgcy0xNy03LjYyNi0xNy0xN1MxNC42MSw2LDIzLjk4NCw2eiIgZmlsbD0iIzAwNDE2ZiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K"
        />
      </div>

      <select class="form-control listagem__select" v-model="filtros.gateway">
        <option value="">Todos os gateways</option>
        <option
          v-for="(gateway, key) in gatewaysDisponiveis"
          v-bind:key="key"
          :value="key"
        >
          {{ gateway }}
        </option>
      </select>

      <select class="form-control listagem__select" v-model="filtros.ambiente">
        <option value="">Ambiente: Todos</option>
        <option value="PRODUCAO">Produção</option>
        <option value="HOMOLOGACAO">Homologação</option>
      </select>

      <div class="listagem__acoes">
        <button v-on:click="openEdit()" class="button button-success">
          <fa-icon icon="plus" />
          Nova Adquirente
        </button>
      </div>
    </div>

    <EmptyState
      v-if="adquirentesFiltradas.length === 0"
      icon="credit-card"
      title="Nenhuma adquirente encontrada"
      :description="
        adquirentes.length === 0
          ? 'Nenhuma forma de pagamento foi configurada ainda. Cadastre a primeira para começar a receber.'
          : 'Não há adquirentes que correspondam aos filtros selecionados. Tente ajustar os critérios de busca.'
      "
    />

    <div v-else class="listagem__table-wrapper">
      <table class="listagem__table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Gateway</th>
            <th>Ambiente</th>
            <th>Ordem</th>
            <th>Captura</th>
            <th>Antifraude 3DS</th>
            <th>Certificados</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="adquirente in adquirentesFiltradas"
            v-bind:key="adquirente.id"
            class="listagem__row"
          >
            <td class="listagem__cell--nome">
              <strong>{{ adquirente.nome }}</strong>
              <br />
              <small>Forma de pagamento: {{ adquirente.cobranca_id }}</small>
            </td>
            <td>
              <span class="label primary">{{ adquirente.gateway }}</span>
            </td>
            <td>
              <span
                class="label"
                :class="
                  adquirente.ambiente === 'PRODUCAO' ? 'success' : 'warning'
                "
              >
                {{
                  adquirente.ambiente === "PRODUCAO"
                    ? "Produção"
                    : "Homologação"
                }}
              </span>
            </td>
            <td>
              <span class="label success">{{ adquirente.ordem }}</span>
            </td>
            <td>
              {{ +adquirente.processa_pgto === 2 ? "2 etapas" : "1 etapa" }}
            </td>
            <td
              :inner-html.prop="adquirente.autenticacao_ativa | booleanHtml"
            ></td>
            <td
              :inner-html.prop="usaCertificados(adquirente) | booleanHtml"
            ></td>
            <td class="listagem__cell--actions">
              <button
                type="button"
                class="button button-primary"
                v-on:click="openEdit(adquirente.id)"
              >
                <fa-icon icon="pencil-alt" />
              </button>
              &nbsp;
              <button
                type="button"
                class="button button-error"
                v-on:click="deleteConfirm(adquirente.id)"
              >
                <fa-icon icon="trash-alt" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { upload, get } from "../../../../helpers/apiRequest";
import Edit from "./Edit";
import EmptyState from "../../../../components/EmptyState";

const INITIAL_ADQUIRENTE = {
  id: "",
  nome: "NOVA ADQUIRENTE",
  ambiente: "HOMOLOGACAO",
  gateway: "CIELO",
  ordem: 1,
  cobranca_id: "BK",
  merchant_key: "",
  merchant_id: "",
  processa_pgto: 2,
  instrucoes: "",
  filiais: [],
  certificados: [],
  certificados_link: [],
};

export default {
  name: "adquirentes",
  props: [
    "adquirentes",
    "cobrancasDisponiveis",
    "gatewaysDisponiveis",
    "salvarAdquirente",
    "removerAdquirente",
    "resetStatus",
    "error",
  ],
  components: {
    Edit,
    EmptyState,
  },
  data() {
    return {
      currentAdquirente: { ...INITIAL_ADQUIRENTE },
      modoDeEdicao: "EDITAR",
      filtros: {
        termo: "",
        gateway: "",
        ambiente: "",
      },
    };
  },
  computed: {
    /**
     * Filtro no cliente: a listagem recebe as adquirentes por prop, sem endpoint paginado.
     */
    adquirentesFiltradas() {
      const termo = this.filtros.termo.trim().toLowerCase();

      return this.adquirentes.filter((adquirente) => {
        const casaTermo =
          !termo ||
          `${adquirente.nome} ${adquirente.gateway}`
            .toLowerCase()
            .indexOf(termo) >= 0;

        const casaGateway =
          !this.filtros.gateway || adquirente.gateway === this.filtros.gateway;

        const casaAmbiente =
          !this.filtros.ambiente ||
          adquirente.ambiente === this.filtros.ambiente;

        return casaTermo && casaGateway && casaAmbiente;
      });
    },
    ordensDisponiveis() {
      const ordens = this.adquirentes.map((_, index) => index + 1);
      return this.modoDeEdicao === "EDITAR"
        ? ordens
        : ordens.concat(this.adquirentes.length + 1);
    },
  },
  methods: {
    /**
     * Certificado é exigido pelas integrações Pix que autenticam por PSP. Antes a coluna
     * marcava apenas o Sicredi, deixando de fora o Itaú, que também usa.
     */
    usaCertificados(adquirente) {
      return (
        ["PIX_SICREDI", "PIX_ITAU", "PIX_INTER"].indexOf(adquirente.gateway) >=
        0
      );
    },
    openEdit(id = "") {
      this.modoDeEdicao = id ? "EDITAR" : "CRIAR";
      this.currentAdquirente =
        this.modoDeEdicao === "EDITAR"
          ? { ...this.adquirentes.find((adquirente) => adquirente.id === id) }
          : { ...INITIAL_ADQUIRENTE };

      this.$modal.show("editAdquirente");
    },
    closeEdit() {
      this.currentAdquirente = INITIAL_ADQUIRENTE;
      this.$modal.hide("editAdquirente");
    },
    resetEdit() {
      this.modoDeEdicao = "EDITAR";
      this.certificados = [];
      this.currentAdquirente = { ...INITIAL_ADQUIRENTE };
      this.resetStatus();
    },
    salvar(modo, adquirente) {
      const instrucoesConteudo = {
        ...adquirente,
        instrucoes: adquirente.conteudo,
      };

      const { conteudo, ...adquirenteData } = instrucoesConteudo;

      this.salvarAdquirente(modo, adquirenteData, () => {
        this.closeEdit();
        this.resetEdit();
      });
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Confirma Remover?",
        text: "Essa ação não poderá ser desfeita",
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      }).then((res) => {
        if (res.value) {
          this.removerAdquirente(id);
        }
      });
    },
  },
};
</script>

<style scoped>
/* As classes de listagem não existem em CSS global: cada tela define as suas. Valores
   copiados de Colaboradores/Colaboradores.vue, para as duas listagens ficarem iguais. */
.search-wrapper {
  position: relative;
  display: block;
}
.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  width: 16px;
  height: 16px;
}
.listagem__filtros {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.listagem__acoes {
  margin-left: auto;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
/* Mesma aparencia do botao de cadastro na tela de Colaboradores: o CSS global deixa o raio em
   2px, e aquela tela redefine para 4px com o icone alinhado por flex. Sem repetir isto aqui, o
   mesmo `button button-success` sai com cantos mais secos em cada tela. */
.button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
}

.listagem__acoes .button {
  height: 38px;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 15px;
  justify-content: center;
}
/* Só em telas estreitas o botão ocupa a largura toda; no desktop fica à direita, pelo
   margin-left: auto da regra acima. O wrapper de media query é o mesmo do padrão. */
@media (max-width: 991px) {
  .listagem__acoes {
    margin-left: 0;
    width: 100%;
  }

  .listagem__acoes .button {
    flex: 1;
  }
}
.listagem__select {
  height: 38px;
  width: auto;
  min-width: 160px;
}
.listagem__table-wrapper {
  border: 1px solid #e4e7ea;
  border-radius: 10px;
  overflow-x: auto;
}
.listagem__table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  font-size: 13px;
}
.listagem__table thead tr {
  background: #f9fafb;
  border-bottom: 1px solid #e4e7ea;
}
.listagem__table thead th {
  padding: 10px 14px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #667085;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.listagem__table tbody td {
  padding: 12px 14px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
  color: #344054;
}
.listagem__row:last-child td {
  border-bottom: none;
}
.listagem__row:hover td {
  background: #f9fafb;
}
.listagem__cell--nome {
  font-weight: 500;
  color: #101828;
}
.listagem__cell--actions {
  text-align: right;
  white-space: nowrap;
  width: 110px;
}
</style>
